import { render, staticRenderFns } from "./NewCampaignKpiSidebar.vue?vue&type=template&id=370b07f5"
import script from "./NewCampaignKpiSidebar.vue?vue&type=script&lang=js"
export * from "./NewCampaignKpiSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports